// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__i0K0f","ant-page-header-heading-title":"styles_ant-page-header-heading-title__3eRX6","table":"styles_table__wxBDy"};